import * as React from 'react';
import {stylesheet} from 'typestyle';
import {NumericFormatter} from '../../../utility/FormatValueUtils';
import {Channel} from '../../../types/Channel';
import {
    DiagramTableBuildingBlock,
    MergedBuildingBlockInstructions,
    NamedDateRangeWithPreviewDateRange,
    ReportBuildingBlock,
} from '../../types/Report';
import LineChartPreview from '../PaperSheetBlocks/LineChartPreview';
import TablePreview from '../PaperSheetBlocks/TablePreview';

interface PreviewDiagramBlockProps {
    targetCurrency?: string;
    buildingBlock: DiagramTableBuildingBlock;
    selectedNamedDateRange?: NamedDateRangeWithPreviewDateRange;
    selectedNamedCompareDateRange?: NamedDateRangeWithPreviewDateRange;
    getMergedBuildingBlockInstructions: (buildingBlock: ReportBuildingBlock) => MergedBuildingBlockInstructions;
    getFullChannelForChannelName: (channelName: string) => Channel;
    moneyFormatToTargetCurrency: (fractions?: number) => NumericFormatter;
}

export default function PreviewDiagramTableBlock({
    targetCurrency,
    buildingBlock,
    selectedNamedDateRange,
    selectedNamedCompareDateRange,
    moneyFormatToTargetCurrency,
    getFullChannelForChannelName,
    getMergedBuildingBlockInstructions,
}: PreviewDiagramBlockProps) {
    const mergedBuildingBlockInstructions = getMergedBuildingBlockInstructions(buildingBlock);
    const {searchDiagrams, productDiagrams} = mergedBuildingBlockInstructions.diagramInstruction
        ? mergedBuildingBlockInstructions.diagramInstruction
        : {searchDiagrams: [], productDiagrams: []};
    const {activeViews} = mergedBuildingBlockInstructions.tableInstruction ? mergedBuildingBlockInstructions.tableInstruction : {activeViews: []};

    if (
        selectedNamedDateRange &&
        (searchDiagrams.length > 0 || productDiagrams.length > 0) &&
        (productDiagrams.length === 0 || searchDiagrams.length === 0) &&
        selectedNamedDateRange &&
        activeViews.length === 1
    ) {
        return (
            <div>
                <div className={diagramTableBlockCss.diagramPreviewContainer}>
                    <LineChartPreview
                        targetCurrency={targetCurrency}
                        dateRange={selectedNamedDateRange.previewDateRange}
                        compareDateRange={selectedNamedCompareDateRange ? selectedNamedCompareDateRange.previewDateRange : undefined}
                        mergedBuildingBlockInstructions={mergedBuildingBlockInstructions}
                        getFullChannelForChannelName={getFullChannelForChannelName}
                    />
                </div>
                <div className={diagramTableBlockCss.tablePreviewContainer}>
                    <TablePreview
                        targetCurrency={targetCurrency}
                        previewModeEnabled={true}
                        diagramCompanionMode={true}
                        lineLimit={0}
                        columns={buildingBlock.columns}
                        dateRange={selectedNamedDateRange.previewDateRange}
                        compareDateRange={selectedNamedCompareDateRange ? selectedNamedCompareDateRange.previewDateRange : undefined}
                        mergedBuildingBlockInstructions={mergedBuildingBlockInstructions}
                        moneyFormatToTargetCurrency={moneyFormatToTargetCurrency}
                        getFullChannelForChannelName={getFullChannelForChannelName}
                    />
                </div>
            </div>
        );
    }
    return null;
}

const diagramTableBlockCss = stylesheet({
    diagramPreviewContainer: {
        position: 'relative',
        height: 300,
    },
    tablePreviewContainer: {
        position: 'relative',
        maxHeight: 300,
    },
});



// WEBPACK FOOTER //
// ./src/report/views/PreviewPaperSheetBlocks/PreviewDiagramTableBlock.tsx